import React from "react";
import "./index.css";
import expiredImage from "../../../../public/images/planExpire/expire.webp";
import Image from "next/image";

const PlanExpired = () => {
  return (
    <div className="plan-expired-wrapper">
      <div className="plan-expired-content">
        <div className="text-section">
          <h1>Expired Account</h1>
          <p className="subtitle">
            Web hosting that scales from easy to expert.
          </p>
          <p className="desc">
            Oops, your session has expired. Please re-authenticate to return to
            your conversation panel.
          </p>
          <p className="admin-link">Contact To Administrator</p>
        </div>
        <div className="image-section">
          <Image src={expiredImage} alt="Expired Account" />
        </div>
      </div>
    </div>
  );
};

export default PlanExpired;
